import { useContext, useEffect, useState } from 'react'
import CheckBox from '../../../../components/common/CheckBox'
import Button from '../../../../components/common/Button'
import CloneMappings from '../../../../components/dtcs/TATMappings/CloneMappings'
import { getRequest, putRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../../../context/global_context'
import DtcDependencies from './DtcDependencies'
import DtcDependencyStore from './context/context'
import TextArea from '../../../common/TextArea'

const DtcEditComponent = () => {
  const [value, dispatch] = useContext(NavContext)

  let { dtc_id, vehicle } = useParams()
  const [payload, setPayload] = useState({
    create_dtc_circuits: false,
    clone_with_existing_mapping: false,
    target_dtcs: [],
    active: false,
    destination_only: false,
    short_description: '',
    description: '',
    description_2: '',
    ecu: '',
    name: '',
  })

  const saveDtcs = async (msg) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Saving DTC is in process',
        showLoader: true,
      },
      notification: {},
    })
    let res = await putRequest(`/api/dtcs/update_dtcs/${dtc_id}/`, payload)
    dispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: `DTC's ${value?.dtc_details[0].name} ${msg} Successfully`,
      },
    })
  }

  useEffect(() => {
    getDtcsList()
  }, [])

  const getDtcsList = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching DTCS Data',
        showLoader: true,
      },
      notification: {},
    })

    let dtcs_res = await getRequest(`/api/dtcs/${dtc_id}/?vehicle=${vehicle}`)

    setPayload({
      ...payload,
      active: dtcs_res.active,
      destination_only: dtcs_res.destination_only,
      description_2: dtcs_res.description_2,
      description: dtcs_res.description,
      short_description: dtcs_res.short_description,
      ecu: dtcs_res.ecu,
      name: dtcs_res.name,
    })

    dispatch({
      type: 'header',
      data: {
        header: '',
        sub_header: 'DTC Edit',
        id: '',
        show_back_btn: true,
        dtc_details: [dtcs_res],
        vehicle: vehicle,
        back_btn_url: `/vehicles/${vehicle}/dtcs`,
      },
    })
  }

  return (
    <div className="w-full bg-tracer-dark-blue mt-5">
      <div className="w-full text-white border-b px-12">
        <div className="font-bold text-xl pt-3 py-3">
          {payload.ecu} - {payload.name}
        </div>
        <div className="flex ">
          <div className="w-1/3 pr-2">
            <TextArea
              name="short_description"
              value={payload.short_description}
              label="Short Description"
              onChange={(e) => {
                setPayload({ ...payload, short_description: e })
              }}
              wrapperClass="p-0"
              isRequired={false}
              maxLength={128}
            />
          </div>
          <div className="w-1/3 pr-2">
            <TextArea
              name="description"
              value={payload.description}
              label="Description"
              onChange={(e) => {
                setPayload({ ...payload, description: e })
              }}
              wrapperClass="p-0"
              isRequired={false}
              maxLength={128}
            />
          </div>
          <div className="w-1/3">
            <TextArea
              name="description_2"
              value={payload.description_2}
              label="Description 2"
              onChange={(e) => {
                setPayload({ ...payload, description_2: e })
              }}
              wrapperClass="p-0"
              isRequired={false}
            />
          </div>
        </div>
        <div className="flex content-center items-center">
          <div className="w-1/3">
            <div className="py-2">
              <span className="flex pt-4 items-center">
                <CheckBox
                  name={'active'}
                  value={payload?.active}
                  checked={payload?.active}
                  onChange={(e) => {
                    setPayload({ ...payload, active: e.target.checked })
                  }}
                />
                <span className="pl-2 text-white">Active</span>
              </span>
            </div>
          </div>
          <div className="w-1/3">
            <div className="py-2 ">
              <span className="flex items-center">
                <CheckBox
                  name={'destination_only'}
                  value={payload?.destination_only}
                  checked={payload?.destination_only}
                  onChange={(e) => {
                    setPayload({
                      ...payload,
                      destination_only: e.target.checked,
                    })
                  }}
                />
                <span className="pl-2 text-white">Destination Only</span>
              </span>
            </div>
          </div>
        </div>
        <div className="flex justify-end">
          <Button
            type="submit"
            className={`cursor-pointer cursor-pointer btn my-4 px-5`}
            onClick={(e) => saveDtcs('Saved')}
            value={'text'}
            text="Save DTC"
          />
        </div>
      </div>
      <div className="w-full border-b px-12 text-white pt-2">
        <div className="font-bold text-xl pt-3">Clone DTC mapping on</div>
        <div className="text-red-600 text-small">
          **From here you can select dtc for which you wanted to clone
        </div>
        <div className="">
          <CloneMappings payload={payload} setPayload={setPayload} />
        </div>
        <div className="flex justify-end">
          <Button
            type="submit"
            className={`cursor-pointer cursor-pointer btn my-4 px-5`}
            onClick={(e) => saveDtcs('Clone')}
            value={'text'}
            text="Save Clone DTC Mapping"
          />
        </div>
      </div>
      <DtcDependencyStore>
        <DtcDependencies />
      </DtcDependencyStore>
    </div>
  )
}

export default DtcEditComponent
